import { schema } from 'normalizr';

const teamSchema = new schema.Entity('team', {}, { idAttribute: 'slug' });

const personSchema = new schema.Entity(
  'people',
  {},
  {
    idAttribute: 'slug',
  }
);

personSchema.define({
  team: teamSchema,
});

const peopleSchema = new schema.Array(personSchema);

const contentSchema = new schema.Entity('content', {}, { idAttribute: 'slug' });
const contentsSchema = new schema.Array(contentSchema);

export default {
  contentSchema,
  contentsSchema,
  personSchema,
  peopleSchema,
  teamSchema,
};



// WEBPACK FOOTER //
// ./src/api/schema.js